/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import QueryString = alm.browser.QueryString;

	export class Meta {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(json:object) {
			this.isAvailable = true;

			const data:object = json['three_dimension_map_meta'];

			this.zoomLevel = data['zoom_level'];

			const from:number[] = data['from'];
			this.tileTopLeft = new THREE.Vector2(from[0], from[1]);

			const to:number[] = data['to'];
			this.tileBottomLeft = new THREE.Vector2(to[0], to[1]);

			this.bounds = Bounds.fromTile(this.tileTopLeft, this.tileBottomLeft, this.zoomLevel);
			this.bounds.calcPixelCoord(this.zoomLevel);

			const query = new QueryString(window.location.href);
			this.demStep = query.getInt('dem_step', -1);
			if (this.demStep < 0) {
				const maxVertexCount = 100000;
				const minStep = 1;
				const maxStep = 5;
				this.demStep = maxStep;
				for (let i = maxStep; i >= minStep; --i) {
					const dimension = this.getDemDimension(i);
					const vertexCount = dimension.x * dimension.y;
					trace('[Meta] dem step =', i, ', dimension =', dimension.x, 'x', dimension.y, ', vertex count =', vertexCount);
					if (vertexCount < maxVertexCount) {
						this.demStep = i;
						this.demDimensionX = dimension.x;
						this.demDimensionY = dimension.y;
					}
				}
			} else {
				const dimension = this.getDemDimension(this.demStep);
				const vertexCount = dimension.x * dimension.y;
				trace('[Meta] dem step =', this.demStep, ', dimension =', dimension.x, 'x', dimension.y, ', vertex count =', vertexCount);
				this.demDimensionX = dimension.x;
				this.demDimensionY = dimension.y;
			}
			this.demUrl = data['url'] + (this.demStep > 1 ? ('?t=' + this.demStep) : '');

			trace('[Meta] dem step is decided :', this.demStep);
			trace('[Meta] raw :', json);
			trace('[Meta]', this);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getIsAvailable():boolean {
			return this.isAvailable;
		}

		private getDemDimension(step:number):{ x:number, y:number } {
			return {
				x: Math.ceil((this.tileBottomLeft.x - this.tileTopLeft.x + 1) * 256 / step),
				y: Math.ceil((this.tileBottomLeft.y - this.tileTopLeft.y + 1) * 256 / step),
			};
		}

		public getZoomLevel():number {
			return this.zoomLevel;
		}

		public getTileTopLeft():THREE.Vector2 {
			return this.tileTopLeft;
		}

		public getTileBottomRight():THREE.Vector2 {
			return this.tileBottomLeft;
		}

		public getBounds():Bounds {
			return this.bounds;
		}

		public getDemUrl():string {
			return this.demUrl;
		}

		public getDemStep():number {
			return this.demStep;
		}

		public getDemDimensionX():number {
			return this.demDimensionX;
		}

		public getDemDimensionY():number {
			return this.demDimensionY;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isAvailable:boolean;

		private zoomLevel:number;

		private tileTopLeft:THREE.Vector2;
		private tileBottomLeft:THREE.Vector2;

		private bounds:Bounds;

		private demUrl:string;
		private demStep:number;
		private demDimensionX:number;
		private demDimensionY:number;
	}
}
